/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewcolumnbusiness3Inputs */

const en_sharereviewcolumnbusiness3 = /** @type {(inputs: Sharereviewcolumnbusiness3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business`)
};

const de_sharereviewcolumnbusiness3 = /** @type {(inputs: Sharereviewcolumnbusiness3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen`)
};

/**
* | output |
* | --- |
* | "Business" |
*
* @param {Sharereviewcolumnbusiness3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewcolumnbusiness3 = /** @type {((inputs?: Sharereviewcolumnbusiness3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewcolumnbusiness3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewcolumnbusiness3(inputs)
	return de_sharereviewcolumnbusiness3(inputs)
});
export { sharereviewcolumnbusiness3 as "shareReviewColumnBusiness" }